import React from 'react';
import NavMenu from './NavMenu'
import SiteFooter from '../SiteFooter';

const LayoutPrivate = ({hideBrand, onNavBarSelect,showExtendedFooter, children, onWebChatButtonClick}) => (

        <div className="flex-wrapper">
            <NavMenu hideBrand={hideBrand} onNavBarSelect={onNavBarSelect} onWebChatButtonClick={onWebChatButtonClick} />

            <div className="content-area">
                {children}
                <div className="clearfix" />
            </div>
            <SiteFooter showExtendedFooter={showExtendedFooter} />
           
        </div>
    
);

export default LayoutPrivate;